import * as React from 'react';
import './index.scss';
// import { StageDefault } from '@/context.ts';
import { fetch, GetGuildRankRsp, RankItem, GuildItem } from '@/fetch.ts';
import None from '@hooks/web/public/none.tsx';
import defaultAvatar from '@images/web/default.png';
import GroupDetail from '@hooks/web/public/groupDetail.tsx';
const { useEffect, useState } = React;
interface Props {
  iStage: number,
}
const GroupFinal: React.FC<Props> = props => {
  const [current, Current] = useState<number>(0);
  const [list, List] = useState<GuildItem[]>([]);
  const [lists, Lists] = useState<any>([]);
  useEffect(() => {
    fetch.getGuildRank(
      {
        iStage: props.iStage,
        iArea: current + 1,
        iRevive: 0,
      },
    )
      .then((rsp: GetGuildRankRsp) => {
        console.log('公会榜单', {
          iStage: props.iStage,
          iArea: current + 1,
          iRevive: 0,
        }, rsp);
        List(rsp.vRank.value.slice(0, 6));
        Lists(rsp.vRsp.value);
      })
  }, [props.iStage, current])
  const [showToast, ShowToast] = useState<boolean>(false);
  const [groupName, GroupName] = useState<string>('');
  const [groupId, GroupId] = useState<number>(0);
  const [datas, Datas] = useState<any>(null);
  const close = () => {
    ShowToast(false);
    GroupName('');
    GroupId(0);
  }
  return (
    <div
      className={'web-groupRank4'}
    >
      {
        <div className='web-groupTab' style={{marginBottom: '0px'}}>
          {
            ['游戏', '娱乐'].map((item: string, index: number) => (
              <div
                className={current === index ? 'groupTabItem on' : 'groupTabItem'}
                key={item}
                onClick={
                  () => {
                    Current(index);
                  }
                }
              >巅峰{item}公会</div>
            ))
          }
        </div>
      }
      <ul className='web-groupList1' >
        {
          list.length !== 0 ?
            (
              list.map((items: GuildItem, index: number) => {
                if (items.iRank <= 3) {
                  return (
                    <li key={items.lCompanyId} style={{marginTop: '50px'}}>
                      <div className='list-top'>
                        <div className='rankNoCover'><div className={`no-${items.iRank > 5 ? 'n' : items.iRank}`}>{items.iRank > 5 ? items.iRank : ''}</div></div>
                        <div className={`avatar avatar-${items.iRank > 3 ? 'n' : items.iRank}`}>
                          <img
                            title={items.sCompanyName}
                            src={items.sCompanyLogoUrl}
                            onError={(event: any): void => {
                              event.target.onerror = null;
                              event.target.src = defaultAvatar;
                            }}
                            onClick={
                              () => {
                                ShowToast(true);
                                GroupName(items.sCompanyName);
                                GroupId(items.lCompanyId);
                                Datas(lists[items.iRank - 1]);
                              }
                            }
                          />
                        </div>
                        <div className='groupMsg'>
                          <h1
                            onClick={
                              () => {
                                ShowToast(true);
                                GroupName(items.sCompanyName);
                                GroupId(items.lCompanyId);
                                Datas(lists[items.iRank - 1]);
                              }
                            }
                          ><span>{items.sCompanyName}</span> <a>详情{'>'}</a></h1>
                          {items.sDesc !== '' && <p>{items.sDesc}</p>}
                        </div>
                        <div className='groupMember'>
                          <div className='singles'>
                          </div>
                          <p></p>
                        </div>
                        <div className='groupScore'>
                          <h1>{items.lScore}</h1>
                          <p>总星光</p>
                        </div>
                      </div>
                      <div className='list-bottom'>
                        <div className='bottom-title'>
                          <i></i>
                          <p>十大战将</p>
                        </div>
                        <div className='bottom-list'>
                          {
                            items.vRank.value.map((item: RankItem, index: number) => {
                              if (index > 9) return '';
                              return (
                                <div key={item.lUid} className='bottom-list-item'>
                                  <div className='imgAvatar'>
                                    <img
                                      title={item.sNickName}
                                      src={item.sLogoUrl}
                                      onError={(event: any): void => {
                                        event.target.onerror = null;
                                        event.target.src = defaultAvatar;
                                      }}
                                      onClick={(): void => {
                                        window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                                      }}
                                    />
                                    {
                                      item.tJump.iLive !== 0 && <i />
                                    }
                                  </div>
                                  <p
                                    onClick={(): void => {
                                      window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank');
                                    }}
                                  >{item.sNickName}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </li>
                  )
                } else {
                  return '';
                }
              })
            ) :
            (
              <None text={`暂无${current === 0 ? '游戏' : '娱乐'}公会数据`} />
            )
        }
      </ul>
      <ul className='web-groupList'
        style={{marginTop: '50px', borderTop: '1px solid rgb(72, 53, 49)'}}
      >
        {
          list.length !== 0 &&
          list.map((items: GuildItem, index: number) => {
            if (items.iRank > 3) {
              return (
                <li key={items.lCompanyId}>
                  <div className='rankNoCover'><div className={`no-${items.iRank > 5 ? 'n' : items.iRank}`}>{items.iRank > 5 ? items.iRank : ''}</div></div>
                  <div className={`avatar avatar-${items.iRank > 3 ? 'n' : items.iRank}`}>
                    <img
                      title={items.sCompanyName}
                      src={items.sCompanyLogoUrl}
                      onError={(event: any): void => {
                        event.target.onerror = null;
                        event.target.src = defaultAvatar;
                      }}
                      onClick={
                        () => {
                          ShowToast(true);
                          GroupName(items.sCompanyName);
                          GroupId(items.lCompanyId);
                          Datas(lists[items.iRank - 1]);
                        }
                      }
                    />
                  </div>
                  <div className='groupMsg'>
                    <h1
                      onClick={
                        () => {
                          ShowToast(true);
                          GroupName(items.sCompanyName);
                          GroupId(items.lCompanyId);
                          Datas(lists[items.iRank - 1]);
                        }
                      }
                    ><span>{items.sCompanyName}</span> <a>详情{'>'}</a></h1>
                    {items.sDesc !== '' && <p>{items.sDesc}</p>}
                  </div>
                  <div className='groupMember'>
                    <div className='singles'>
                      {
                        items.vRank.value.map((single: RankItem, index: number) => {
                          if (index > 2) return '';
                          return (
                            <div className='single' key={single.lUid}>
                              <img
                                title={single.sNickName}
                                src={single.sLogoUrl}
                                onError={(event: any): void => {
                                  event.target.onerror = null;
                                  event.target.src = defaultAvatar;
                                }}
                                onClick={(): void => {
                                  window.open('https://m.huya.com/' + single.tJump.iRoomId, '_blank');
                                }}
                              />
                              {
                                single.tJump.iLive !== 0 &&
                                <i
                                  className='living'
                                ></i>
                              }
                            </div>
                          );
                        })
                      }
                    </div>
                    <p>王牌主播</p>
                  </div>
                  <div className='groupScore'>
                    <h1>{items.lScore}</h1>
                    <p>总星光</p>
                  </div>
                </li>
              )
            } else {
              return '';
            }
          })
        }
      </ul>
      {
        showToast &&
        <GroupDetail
          close={close}
          groupName={groupName}
          groupId={groupId}
          iStage={props.iStage}
          iArea={current + 1}
          data={datas}
        />
      }
    </div>
  )
}

export default GroupFinal;